import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { graphql, useStaticQuery } from "gatsby"
import React, { useEffect, useState } from "react"
import Button from "../../../shared/components/atoms/button/button"
import { siteUrl } from "../../../shared/utils/siteUrl"

import "./section-your-keys.scss"

const SectionYourKeys = ({ mobile }) => {
  const resultQuery = useStaticQuery(
    graphql`
      query PATERN_INFO_YOUR_KEYS {
        allContentfulNolHomeTercerNivel(
          filter: { slug: { in: ["mis-puntos", "mis-puntos/"] } }
        ) {
          edges {
            node {
              node_locale
              slug
              misPuntosHome {
                tituloBanner
                descripcionBanner {
                  json
                }
                imagenesDeBanner {
                  description
                  file {
                    url
                  }
                  title
                }
              }
              ctaMisPuntosHome
              ctaMisPuntosHomeLogueada
              redireccionCtaMisPuntosHome
              redireccionCtaMisPuntosHomeLogueada
            }
          }
        }
      }
    `
  )

  const [isLogIn, setIsLogIn] = useState(false)
  const [buttonActive, setButtonActive] = useState(0)
  const [activeCollapse, setActiveCollapse] = useState(false)

  const hostLink = siteUrl + "/"

  const buttonOptions = resultQuery.allContentfulNolHomeTercerNivel.edges.filter(
    e => e.node.node_locale === process.env.LOCALE
  )[0].node.misPuntosHome
  const homeMyPoints = resultQuery.allContentfulNolHomeTercerNivel.edges.filter(
    e => e.node.node_locale === process.env.LOCALE
  )[0].node

  useEffect(() => {
    setIsLogIn(localStorage.getItem("TOKEN_INFO"))
  }, [])

  return (
    <div className="f-section-your-keys-container">
      <span className="f-curve-effect-your-keys" />
      <span className="f-section-your-keys-container-background" />
      <div className="f-section-your-keys-container-wrap">
        <div
          className={
            "f-section-your-keys-container-wrap-img " +
            (mobile ? "f-img-none" : "")
          }
        >
          <img src={require("../../../assets/images/LOGO-2.webp")} alt="Logo" loading="lazy" />
        </div>
        <div className="f-section-your-keys-container-wrap-info">
          {!mobile ? (
            <div className="f-section-your-keys-container-wrap-info-header">
              {buttonOptions.map((button, index) => (
                <Button
                  key={index}
                  title={button.tituloBanner}
                  className={
                    "fourth-pink btn-small " +
                    (buttonActive === index ? "btn-small-select" : "")
                  }
                  onClick={e => {
                    e.preventDefault()
                    setButtonActive(index)
                  }}
                />
              ))}
            </div>
          ) : (
            <div className="f-collapse-filter">
              <div
                className="f-active-filter"
                onClick={() => setActiveCollapse(true)}
              >
                <label className="f-active-title">
                  {buttonOptions[buttonActive].tituloBanner}
                </label>
                <span
                  className={
                    "f-icon icon-down f-icon-down " +
                    (activeCollapse ? "f-arrow-active" : "")
                  }
                />
              </div>
              <ul
                className={
                  "f-fitler-options " +
                  (activeCollapse ? "f-collapse-active" : "")
                }
              >
                {buttonOptions.map((button, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      setButtonActive(index)
                      setActiveCollapse(false)
                    }}
                    className={
                      "f-filter-item " +
                      (buttonActive === index ? "f-active-item" : "")
                    }
                  >
                    {button.tituloBanner}
                  </li>
                ))}
              </ul>
            </div>
          )}

          <div className="f-section-your-keys-container-wrap-info-description">
            <div className="f-section-your-keys-container-wrap-info-description-img">
              <img
                src={buttonOptions[buttonActive].imagenesDeBanner[0].file.url}
                loading="lazy"
                alt={
                  buttonOptions[buttonActive].imagenesDeBanner[0].description
                }
              />
            </div>
            <div className="f-section-your-keys-container-wrap-info-description-text">
              {documentToReactComponents(
                buttonOptions[buttonActive].descripcionBanner.json
              )}
            </div>
          </div>
          <Button
            title={
              isLogIn
                ? homeMyPoints.ctaMisPuntosHomeLogueada
                : homeMyPoints.ctaMisPuntosHome
            }
            className="new-dark-blue "
            onClick={e => {
              e.preventDefault()
              window.location =
                hostLink +
                (isLogIn
                  ? homeMyPoints.redireccionCtaMisPuntosHomeLogueada
                  : homeMyPoints.redireccionCtaMisPuntosHome)
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default SectionYourKeys
